<template>
  <div class="notice_dialog" :class="{  }" id="be-notice-background">
    <div class="dialog_content be-notice-wrap" :id="this.data._id" :class="this.data._id" :style="contentStyle" v-html="this.data.content">
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'NoticePopup',
  props: {
    data: {
      type: Object,
      required: false
    },
    yes: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    no: {
      type: String,
      default () {
        return this.$t('common.no')
      }
    },
    ok: {
      type: String,
      default () {
        return this.$t('common.ok')
      }
    },
    cancel: {
      type: String,
      default () {
        return this.$t('common.cancel')
      }
    },
    yesValue: {
      default: true
    },
    noValue: {
      default: false
    },
    dimmed: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      rawData: null
    }
  },
  mounted () {
    const that = this
    const popupId = this.data._id
    const con = document.getElementById(this.data._id)
    const closeNodes = con.querySelectorAll('[data-func=close]')
    const checkElems = con.querySelectorAll('input[type=checkbox]')
    for (let i = 0, iLen = checkElems.length; i < iLen; i++) {
      const checkElem = checkElems[i]
      if (checkElem) {
        checkElem.classList.add('icon--dashboard-chkbox')
      }
    }
    for (let i = 0, iLen = closeNodes.length; i < iLen; i++) {
      const item = closeNodes[i]
      item.addEventListener('click', function () {
        const cookieContaniner = con.querySelector('[data-refresh]')
        if (cookieContaniner) {
          const cookieRefreshType = cookieContaniner.getAttribute('data-refresh')
          const checkElem = cookieContaniner.parentNode.querySelector('input')

          if (checkElem) {
            let bCheckd = checkElem.checked
            if (item.tagName === 'LABEL') bCheckd = true
            if (bCheckd) {
              let today = new Date()
              /* cookieRefreshType value is never or tomorrow */
              if (cookieRefreshType === 'never') {
                today.setFullYear(2999, 11, 31)
              }
              today.setHours(23, 59, 59)

              Cookies.set('noticePopup' + popupId, '1', {
                expires: today
              })
            }
          } else {
            let today = new Date()
            Cookies.set('noticePopup' + popupId, '1', {
              expires: today
            })
          }
        }
        that.onCloseClick('notice')
      }, false)
    }
  },
  methods: {
    onCloseClick (value) {
      if (this.$close) {
        // called by vue-modal-dialogs
        this.$close(value)
      } else {
        // called by normal component
        this.$emit('onCloseClick', value)
      }
    }
  }
}
</script>

<style lang="scss">
.notice_dialog {
  pointer-events: auto;
  position: absolute;
  top: 0;
  left: 0;
  width:100%;
  z-index: 999999;

  &.fixed {
    position: fixed;
  }

  &.dimmed {
    pointer-events: auto;
    background-color: rgba(0, 0, 0, 0.5);
  }

  icon--close14{
    position: absolute;
    top: 12px;
    right: 12px;
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
  }

  .dialog_content {
    width: 100%;

    .icon {
      margin-bottom: 13px;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #444;
      margin-bottom: 10px;
      line-height: 1.2;

      &.warning {
        color: $brandColor;
      }
    }

    .action {
      button {
        margin: 0 3px;
      }
    }
  }
}
</style>
